<template>
    <div class="single-filter month-filter search-filter-dropdown">
        <div class="dropdown dropdown-with-animation keep-inside-clicks-open">
            <a href="#"
               class="btn btn-filter px-3"
               :class="{'applied': isApply}"
               :id="filterId"
               data-toggle="dropdown"
               aria-haspopup="true" aria-expanded="false">
                {{ isApply ? formattedValue : label }}
                <span class="clear-icon" v-if="isApply" @click.prevent="clear($event)">
                    <app-icon name="x"/>
                </span>
            </a>

        <div class="dropdown-menu p-3 mt-1" style="min-width: 260px;">
            <div class="d-flex align-items-center justify-content-center mb-3">
                <a href="#" class="text-muted"
                   @click.prevent="changeYear('previous')">
                    <app-icon name="chevron-left"/>
                </a>
                
                <div class="mx-3 font-weight-bold">
                    {{ currentYear }}
                </div>
                
                <a href="#" class="text-muted"
                   @click.prevent="changeYear('next')">
                    <app-icon name="chevron-right"/>
                </a>
            </div>
            <div class="row">
                <div class="col-4 mb-2 text-center" v-for="(month, index) in months" :key="index">
                    <a href="#" :class="`single-month p-2 rounded d-block ${isApply && currentMonthIndex === index && currentYear === selectedYear ? 'bg-brand-color text-white' : 'text-dark'}`"
                       @click.prevent="selectMonth(index)" style="text-decoration: none;">
                        {{ month.short }}
                    </a>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import {FilterMixin} from './mixins/FilterMixin';
import CoreLibrary from "../../helpers/CoreLibrary";
import moment from 'moment-timezone'
import {localTimeZone} from "../../../common/Helper/Support/DateTimeHelper";

export default {
    name: "MonthFilter",
    extends: CoreLibrary,
    mixins: [FilterMixin],
    props: {
        label: {
            type: String,
            default: function () {
                return this.$t('month')
            }
        },
        active: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isApply: false,
            currentYear: parseInt(moment().tz(localTimeZone).format('YYYY')),
            selectedYear: null,
            currentMonthIndex: null,
            value: null,
        }
    },
    computed: {
        months() {
            return Array.apply(0, Array(12)).map((_, i) => {
                return {
                    'short': moment().tz(localTimeZone).month(i).format('MMM'),
                    'full': moment().tz(localTimeZone).locale(window.appLanguage).month(i).format('MMMM')
                };
            });
        },
        formattedValue() {
            if (!this.value) return '';
            return this.value;
        }
    },
    mounted() {
        this.setActiveValue();

        this.$hub.$on('clearAllFilter-' + this.tableId, () => {
            if (this.active) {
                this.setActiveValue();
                return;
            }

            this.isApply = false;
            this.value = null;
            this.selectedYear = null;
            this.currentMonthIndex = null;
        });
    },
    methods: {
        setActiveValue() {
            if (!this.active) {
                return false;
            }

            const [year, month] = this.active.split('-');

            if (!year || !month) {
                return false;
            }

            this.currentYear = parseInt(year);
            this.selectedYear = parseInt(year);
            this.currentMonthIndex = parseInt(month) - 1;
            this.value = this.active;
            this.isApply = true;

            return true;
        },
        changeYear(state) {
            if (state === 'previous') {
                this.currentYear = this.currentYear - 1;
            } else {
                this.currentYear = this.currentYear + 1;
            }
        },
        selectMonth(index) {
            this.currentMonthIndex = index;
            this.selectedYear = this.currentYear;
            
            // Format to YYYY-MM
            const monthStr = (index + 1).toString().padStart(2, '0');
            this.value = `${this.currentYear}-${monthStr}`;
            
            this.isApply = true;
            this.sendValue(this.value);
            
            // Auto close dropdown
            $(`#${this.filterId}`).dropdown('toggle');
        },
        clear(e) {
            e.stopPropagation();
            if (this.setActiveValue()) {
                this.sendValue(this.active);
                return;
            }

            this.isApply = false;
            this.value = null;
            this.selectedYear = null;
            this.currentMonthIndex = null;
            this.sendValue('');
        },
        sendValue(value) {
            this.returnValue(value);
        }
    }
}
</script>

<style scoped>
.single-month {
    cursor: pointer;
    transition: all 0.2s;
}
.single-month:hover {
    background-color: #f1f1f1;
}
.bg-brand-color {
    background-color: #4466f2 !important; /* Adjust if hotelcrm brand color is different */
}
</style>
